import http from "@/api/http.js";

export function getLocations(params = {}) {
  return http.get("/warehouse_locations", { params }).then(res => res.data);
}

export function createLocation(data) {
  return http.post("/warehouse_locations", data).then(res => res.data);
}

export function deleteLocation(id) {
  return http.delete(`/warehouse_locations/${id}`).then(res => res.data);
}

export function downloadTemplate() {
  return http
    .get("/warehouse_locations/template", {
      responseType: "blob",
      transformResponse: []
    })
    .then(res => {
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "locations_template.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });
}

export function uploadLocations(file) {
  const formData = new FormData();
  formData.append("file", file);
  return http
    .post("/warehouse_locations/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      transformResponse: [
        function(data) {
          try {
            return JSON.parse(data);
          } catch {
            return data;
          }
        }
      ]
    })
    .then(res => res.data);
}
